// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'folder-nested-solid';

export const Component = () => (
  <path d='M9.855 10.777V6.85H2.958v11.781h6.897v-3.927c0-.24.096-.479.287-.67a.946.946 0 0 1 .67-.288h4.31c.432 0 .72.191.862.527l.72 1.436h4.932c.239 0 .479.096.67.288a.946.946 0 0 1 .288.67v6.849a.977.977 0 0 1-.288.718.943.943 0 0 1-.67.288H10.813a.946.946 0 0 1-.67-.288.976.976 0 0 1-.288-.718v-3.88H2.958a.837.837 0 0 1-.67-.335.946.946 0 0 1-.288-.67V.478C2 .144 2.144 0 2.479 0c.335 0 .479.144.479.479V5.89h6.897V1.963c0-.239.096-.479.287-.718a.946.946 0 0 1 .67-.288h4.31c.432 0 .72.191.862.575l.72 1.39h4.932c.239 0 .479.095.67.287.192.239.288.478.288.718v6.849a.977.977 0 0 1-.288.719.943.943 0 0 1-.67.287H10.813a.946.946 0 0 1-.67-.287.976.976 0 0 1-.288-.72v.002Z' />
);

export const viewBox = '0 0 25 25';
